import { render, staticRenderFns } from "./proposals.vue?vue&type=template&id=0c221188&scoped=true"
import script from "./proposals.vue?vue&type=script&lang=js"
export * from "./proposals.vue?vue&type=script&lang=js"
import style0 from "./proposals.vue?vue&type=style&index=0&id=0c221188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c221188",
  null
  
)

export default component.exports